import { AccordionDetails, Button, FormControl, FormControlLabel, Grid, Radio, RadioGroup, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useUser } from 'src/components/hooks/useUser';
import { sendRequest } from 'src/hooks/useFetch';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { clearMessage, setMessage } from 'src/store/Message';
import { ISIVChecklistConfirmPage } from 'src/types/SIVChecklist';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { formatInput } from 'src/util/STR';
import { useFieldTranslation } from '../../fields/useFieldTranslation';
import {
  IConfirmPageMandatory,
  ISIVChecklistMandatory,
  ISIVChecklistModifiedKeys,
  ISIVChecklistModifiedKeysOfKeys,
  MandatoryData
} from './useSivChecklist';
import ESignConsentReAuth from 'src/components/common/ESignConsentReAuth';
import { useLazySetESignQuery } from 'src/services/ESignAPI';
import { getUTCDateTimeOfNow } from 'src/util/util';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';
import { hideLoader, showLoader } from 'src/store/Loader';
import { useValidUserForReAuth } from 'src/components/hooks/useValidUserForReAuth';
import { setIsSaveButtonDisable } from 'src/store/sivCheckList';
import { useLazyGetSivChecklistQuery } from 'src/services/SivChecklist';

export interface IConfirmPage {
  getSivChecklistData: (key: ISIVChecklistModifiedKeysOfKeys, add: boolean) => void;
  saveDisable: boolean;
  isUpdate: boolean;
  confirmPageData: ISIVChecklistConfirmPage;
  updateConfirmPage: (data: ISIVChecklistConfirmPage) => void;
  setIsChange: (step: ISIVChecklistModifiedKeys, key: ISIVChecklistModifiedKeysOfKeys, val: boolean) => void;
  isChange: boolean;
  updateSIVChecklistMandatoryData: (key: keyof ISIVChecklistMandatory, value: MandatoryData) => void;
  mandatory: IConfirmPageMandatory;
  validateconfirmPage: any;
  validateAllAccordion: any;
  checkedInStartDate: any;
  isPublished: boolean;
  SignatureBreaking: () => void;
  notifyUser: any;
  validationObj: any;
  setValidationObj: any;
}

const ConfirmPage: React.FunctionComponent<IConfirmPage> = ({
  saveDisable,
  getSivChecklistData,
  confirmPageData,
  isUpdate,
  updateConfirmPage,
  setIsChange,
  isChange,
  mandatory,
  updateSIVChecklistMandatoryData,
  validateconfirmPage,
  validateAllAccordion,
  checkedInStartDate,
  isPublished,
  SignatureBreaking,
  notifyUser,
  validationObj,
  setValidationObj
}: any) => {
  const { isValidUserForReAuth } = useValidUserForReAuth();
  const [openSignConsent, setOpenSignConsent] = useState(false);
  const { selectedAppSection } = useSelectedAppInfo();
  const value = new Date('2014-08-18T21:11:54');
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry: any = useAppSelector(state => state.site.selectedCountry);
  const selectedSite: any = useAppSelector(state => state.site.selectedSite);

  const user = useUser();
  const selectedRowData: any = useAppSelector(state => state.sivCheckList.selectedRowData);
  const isValidsiteInfoData = () => {
    const newValidObj: any = { ...validationObj };
    const validationArr: any = [];
    for (const key of Object.keys(validationObj)) {
      if (confirmPageData[key] === '' || confirmPageData[key] === null) {
        newValidObj[key] = true;
        validationArr.push(false);
      }
    }
    setValidationObj(newValidObj);
    if (validationArr.includes(false)) {
      return false;
    } else {
      return true;
    }
  };

  const { getPreferredDateTimeInLocal } = usePreferedDateFormat();
  const dispatch = useDispatch();
  const dispatchApp = useAppDispatch();
  const { checkPermission } = usePermissionWrapper();
  const isDisable = checkPermission('update_siv_checklist');
  const isSignDisable = checkPermission('siv_checklist_reviewer_sign');
  const isNotifyUser = notifyUser == user.user ? true : false;
  //const selectedRowData: any = useAppSelector(state => state.sivCheckList.selectedRowData);
  const {
    sivcDataUpdateSuccessMsg,
    sivcMendatoryInfoErrorMsg,
    sivcErrorMsg,
    checklistConfirm,
    applicationModuleSection
  } = useFieldTranslation();
  const [getSivCheckList] = useLazyGetSivChecklistQuery();
  const saveButtonDisable: any = useAppSelector(state => state.sivCheckList.disableSaveButtonProps);
  const handleCheck1 = (e: any) => {
    const val = e.target.value;
    const formattedVal = typeof val === 'string' ? formatInput(val) : val;
    const data = formattedVal;
    if (e.target.type === 'radio' && data === 'Y') {
      updateConfirmPage({ ...confirmPageData, [e.target.name]: data, [`${e.target.name}_comm`]: '' });
      updateSIVChecklistMandatoryData('confirmPage', { ...mandatory, [e.target.name]: false });
    } else {
      updateConfirmPage({ ...confirmPageData, [e.target.name]: data });
    }
    const validateKey = `${e.target.name.replace('_comm', '')}`;
    if (e.target.name?.indexOf('_comm') !== -1) {
      if (!(value && value !== null && data !== '')) {
        updateSIVChecklistMandatoryData('confirmPage', { ...mandatory, [validateKey]: true });
      } else {
        updateSIVChecklistMandatoryData('confirmPage', { ...mandatory, [validateKey]: false });
      }
    }
    dispatch(setIsSaveButtonDisable({ ...saveButtonDisable, confirm: false }));
    setConfirmExitValue(dispatch, true);
  };

  const handleCheck2 = (e: any) => {
    const val = e.target.value;
    const formattedVal = typeof val === 'string' ? formatInput(val) : val;
    const data = formattedVal;
    dispatchApp(clearMessage());
    if (e.target.type === 'radio' && data === 'Y') {
      updateConfirmPage({
        ...confirmPageData,
        [e.target.name]: data,
        [`${e.target.name}_comm`]: ''
      });
      updateSIVChecklistMandatoryData('confirmPage', {
        ...mandatory,
        [e.target.name]: false
      });
    } else {
      updateConfirmPage({ ...confirmPageData, [e.target.name]: data });
    }
    const validateKey = `${e.target.name.replace('_comm', '')}`;
    if (e.target.name?.indexOf('_comm') !== -1) {
      if (!(value && value !== null && data !== '')) {
        updateSIVChecklistMandatoryData('confirmPage', { ...mandatory, [validateKey]: true });
      } else {
        updateSIVChecklistMandatoryData('confirmPage', { ...mandatory, [validateKey]: false });
      }
    }
    dispatch(setIsSaveButtonDisable({ ...saveButtonDisable, confirm: false }));
    setConfirmExitValue(dispatch, true);
  };

  const [sivChecklistSignData, setSivChecklistSignData] = useState({
    name_of_signature: 'siv_checklist_signature',
    signed_by: '',
    name_of_date_field: 'siv_checklist_date',
    signed_date: '',
    signed_reason: ''
  });
  const [setESignature] = useLazySetESignQuery();

  const checkValidationOnAllAccordion = () => {
    if (validateAllAccordion()) {
      setOpenSignConsent(true);
    } else {
      dispatch(setMessage({ msgDetails: 'Missing mandatory information', severity: 'error' }));
    }
  };
  const handleSivChecklistSign = async (data: any = {}) => {
    if (data.success) {
      if (!isValidUserForReAuth(data.records.user_name)) {
        dispatch(setMessage({ msgDetails: `Please e-sign with the logged in username`, severity: 'error' }));
      } else {
        setOpenSignConsent(false);
        dispatch(showLoader());
        const dataObj = {
          id: confirmPageData.id,
          username: data.records.user_name,
          password: data.records.password,
          module_name: applicationModuleSection.sivChecklist,
          name_of_signature: sivChecklistSignData.name_of_signature,
          name_of_date_field: sivChecklistSignData.name_of_date_field,
          columns_to_change: {
            reason: data.records.sign_reason,
            siv_checklist_print_name: user.user,
            updated_by: user.user
          }
        };
        setSivChecklistSignData({
          ...sivChecklistSignData,
          signed_by: user.user,
          signed_date: getUTCDateTimeOfNow(),
          signed_reason: data.records.sign_reason
        });
        const signatureResponse: any = await setESignature({
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          application: process.env.REACT_APP_NAME,
          application_section: selectedAppSection,
          application_module_section: applicationModuleSection.sivChecklist,
          data: dataObj
        });
        if (signatureResponse.isSuccess) {
          const updatedValidatoinObj = {
            ...validationObj,
            siv_checklist_date: false,
            siv_checklist_signature: true
          };
          setValidationObj(updatedValidatoinObj);
          setConfirmExitValue(dispatch, true);
          dispatch(setMessage({ msgDetails: 'SIV Checklist Signed', severity: 'success' }));
          isChange = true;
          setConfirmExitValue(dispatch, false);
          getSivChecklistData('confirmPage', false);
          getSivCheckList({
            monitoring_visit_id: selectedRowData.id,
            site_id: selectedSite,
            study_id: studyId,
            country: selectedCountry,
            application: process.env.REACT_APP_NAME
          });
        } else if (signatureResponse.isError) {
          confirmPageData = {
            ...confirmPageData,
            siv_checklist_signature: '',
            siv_checklist_date: '',
            siv_checklist_print_name: '',
            reason: ''
          };
          dispatch(setMessage({ msgDetails: `Authorization for ${data.records.user_name} failed`, severity: 'error' }));
        }
        dispatch(hideLoader());
      }
    }
  };

  useEffect(() => {
    getSivChecklistData('confirmPage', false);
  }, []);
  const updateConfirmData = async () => {
    const options = {
      site_id: selectedSite,
      study_id: studyId,
      data: {
        updated_by: user.user,
        monitoring_visit_id: selectedRowData.id,
        is_published: false,
        siv_checklist: {
          step_three: {
            confirm: {
              siv_checklist_siv_performed: confirmPageData.siv_checklist_siv_performed,
              siv_checklist_not_performed: confirmPageData.siv_checklist_not_performed
            }
          }
        }
      },
      pathVariables: {
        country: selectedCountry,
        appName: process.env.REACT_APP_NAME
      }
    };
    try {
      if (isChange) {
        if (isUpdate === true) {
          await sendRequest('update_sivChecklist_data', options);
          getSivChecklistData('confirmPage', false);
          getSivCheckList({
            monitoring_visit_id: selectedRowData.id,
            site_id: selectedSite,
            study_id: studyId,
            country: selectedCountry,
            application: process.env.REACT_APP_NAME
          });
          if (isPublished) {
            await SignatureBreaking();
            getSivChecklistData('confirmPage', false);
            getSivCheckList({
              monitoring_visit_id: selectedRowData.id,
              site_id: selectedSite,
              study_id: studyId,
              country: selectedCountry,
              application: process.env.REACT_APP_NAME
            });
            setValidationObj({
              siv_checklist_siv_performed: false,
              siv_checklist_not_performed: false
            });
          }
          getSivChecklistData('confirmPage', false);
          dispatchApp(setMessage({ msgDetails: sivcDataUpdateSuccessMsg, severity: 'success' }));
          setConfirmExitValue(dispatch, false);
          setIsChange('Step3', 'confirmPage', false);
        } else {
          await sendRequest('create_sivChecklist_data', options);
          dispatchApp(setMessage({ msgDetails: sivcDataUpdateSuccessMsg, severity: 'success' }));
          setConfirmExitValue(dispatch, false);
          getSivChecklistData('confirmPage', true);
          setIsChange('Step3', 'confirmPage', false);
        }
      } else if (validateconfirmPage) {
        dispatchApp(setMessage({ msgDetails: 'No data modified', severity: 'info' }));
      } else {
        dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
      }
      dispatch(setIsSaveButtonDisable({ ...saveButtonDisable, confirm: true }));
    } catch (e) {
      dispatchApp(setMessage({ msgDetails: sivcErrorMsg, severity: 'error' }));
    }
  };

  const handleSave = () => {
    if (!isValidsiteInfoData()) {
      dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
    } else {
      updateConfirmData();
    }
  };

  return (
    <>
      <AccordionDetails className="sq-checklist-tab">
        <Grid container className="checklist-radio-actions">
          <Grid md={12}>
            <Grid container>
              <Grid md={12}>{checklistConfirm.label1} </Grid>
            </Grid>
            <ul>
              <li>
                <Grid container>
                  <Grid md={9}>
                    {checklistConfirm.label2}
                    <span style={{ color: 'red' }}>* </span>
                  </Grid>
                  <Grid md={3}>
                    <FormControl>
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="siv_checklist_siv_performed"
                        onChange={handleCheck1}
                        value={confirmPageData.siv_checklist_siv_performed}
                      >
                        <FormControlLabel
                          disabled={!isDisable || saveDisable || !checkedInStartDate}
                          value="Y"
                          control={<Radio />}
                          label="Yes"
                        />
                        <FormControlLabel
                          disabled={!isDisable || saveDisable || !checkedInStartDate}
                          value="N"
                          control={<Radio />}
                          label="No"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                </Grid>
              </li>
              <li>
                <Grid container>
                  <Grid md={9}>
                    {checklistConfirm.label3} <span style={{ color: 'red' }}>* </span>
                  </Grid>
                  <Grid md={3}>
                    <FormControl>
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="siv_checklist_not_performed"
                        onChange={handleCheck2}
                        value={confirmPageData.siv_checklist_not_performed}
                      >
                        <FormControlLabel
                          disabled={!isDisable || saveDisable || !checkedInStartDate}
                          value="Y"
                          control={<Radio />}
                          label="Yes"
                        />

                        <FormControlLabel
                          disabled={!isDisable || saveDisable || !checkedInStartDate}
                          value="N"
                          control={<Radio />}
                          label="No"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                </Grid>
              </li>
            </ul>
            <Grid container>
              <Grid md={3} sx={{ pt: 3 }}>
                {checklistConfirm.label4}: <span style={{ color: 'red' }}>* </span>
              </Grid>
              <Grid md={9} sx={{ pt: 2.5, pl: 10 }}>
                {confirmPageData?.siv_checklist_signature ? (
                  <div style={{ marginTop: '4px' }}>
                    <span className="signedInfo">
                      Signed by <strong>{confirmPageData?.siv_checklist_signature}</strong> on{' '}
                      <span color="text.secondary">
                        {getPreferredDateTimeInLocal(confirmPageData?.siv_checklist_date)}
                      </span>{' '}
                      <br />
                      <span className="signReasonrow">
                        <span color="text.secondary">Reason:</span> &ldquo;{confirmPageData?.reason}
                        &rdquo;
                      </span>
                    </span>
                  </div>
                ) : (
                  <Button
                    variant="contained"
                    onClick={checkValidationOnAllAccordion}
                    disabled={!isSignDisable || !isNotifyUser || !checkedInStartDate}
                  >
                    Sign
                  </Button>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </AccordionDetails>
      <Grid container className="fixed-buttons-block">
        <Grid md={12} display="flex" justifyContent="flex-end">
          <Stack spacing={2} direction="row">
            {isDisable ? (
              <Button variant="text" onClick={handleSave} disabled={saveButtonDisable.confirm || !checkedInStartDate}>
                SAVE
              </Button>
            ) : (
              ''
            )}
          </Stack>
        </Grid>
        {openSignConsent && (
          <ESignConsentReAuth
            openSignConsent={openSignConsent}
            setOpenSignConsent={setOpenSignConsent}
            handleConfirmSign={handleSivChecklistSign}
          />
        )}
      </Grid>
    </>
  );
};

export default ConfirmPage;
